import { useEffect, useRef } from 'react';

import { useAppSelector } from 'application/providers/StoreProvider';
import { useNotificationContext } from 'application/providers/NotificationProvider';
import { NotificationColors } from 'application/providers/NotificationProvider/types';
import { selectAcceptanceAdvancedError } from 'application/store/slices/acceptanceAdvancedSlice';

const ACCEPTANCE_ADVANCED_ERROR_NOTIFICATION_DELAY = 5 * 60 * 1000;

export const useAcceptanceAdvancedErrorNotification = (): void => {
  const error = useAppSelector(selectAcceptanceAdvancedError());
  const notification = useNotificationContext();

  const shownForError = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (error && shownForError.current !== error) {
      shownForError.current = error;

      notification.showNotification({
        type: NotificationColors.ERROR,
        children: error,
        delay: ACCEPTANCE_ADVANCED_ERROR_NOTIFICATION_DELAY,
      });
    }

    if (!error) {
      shownForError.current = undefined;
    }
  }, [error, notification]);
};
